export default "__VITE_ASSET__BxAiboUm__"